import React, { useEffect, useState } from "react";
import person from "../Assets/women.png";
import logo from "../Assets/Logo.png";
import { getSelfBookiing, BookingCancel } from "../Common/apis.js";

const BookingDetails = () => {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [cancelId, setCancelId] = useState(null);

  useEffect(() => {
    fetchBookingData();
  }, []);

  const fetchBookingData = async () => {
    try {
      const result = await getSelfBookiing();
      setBookingData(result?.data || []);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmCancel = async () => {
    try {
      await BookingCancel(cancelId);
      fetchBookingData();
      // Toast or alert for success
    } catch (error) {
      console.error("Error cancelling booking:", error);
    } finally {
      setShowCancelDialog(false);
    }
  };

  const handleCancel = (id, date, startTime) => {
    // if (!startTime) {
    //   alert("Start time is missing for this booking.");
    //   return;
    // }
    // Ensure proper formatting of date and time
    // const formattedStartTime = new Date(startTime).toISOString().split("T")[1];
    // const bookingDateTime = new Date(
    //   `${date.split("T")[0]}T${formattedStartTime}`
    // );
    // const currentTime = new Date();
    // const timeDifference = bookingDateTime - currentTime;
    // if (timeDifference > 86400000) {
      setCancelId(id);
      setShowCancelDialog(true);
    // } else {
    //   alert("Cancellation is not allowed within 24 hours of the booking.");
    // }
  };

  // Function to download invoice
  const handlePrint = (id) => {
    const invoiceElement = document.getElementById(`invoice-${id}`);
    if (invoiceElement) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 20px; }
              .invoice-container { width: 210mm; margin: auto; padding: 20px; background: #fff; border: 1px solid #ddd; }
              .invoice-header { text-align: center; margin-bottom: 20px; }
              .invoice-header img { max-width: 100px; }
              .invoice-title { font-size: 24px; color: #849348; }
              .invoice-table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              .invoice-table td, .invoice-table th { border: 1px solid #ddd; padding: 10px; text-align: left; }
              .invoice-footer { text-align: center; margin-top: 20px; font-size: 12px; color: #555; }
            </style>
          </head>
          <body>
            ${invoiceElement.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  return (
    <div className="profile-plan">
      <h2 className="Select">My Bookings</h2>
      <br />
      <div className="encourage-cards">
        {bookingData.length > 0 ? (
          bookingData.map((booking) => {
            const {
              _id,
              courseId,
              date,
              startTime,
              endTime,
              status,
              bookingType
            } = booking;
            // const formattedStartTime = new Date(startTime)
            //   .toISOString()
            //   .split("T")[1];
            console.log(booking)
            const bookingDate = new Date(date); // e.g., 2025-05-14T00:00:00.000Z
            const [hours = 0, minutes = 0] = startTime ? startTime.split(":").map(Number) : [0, 0];
            const bookingDateTime = new Date(bookingDate);
            bookingDateTime.setHours(hours);
            bookingDateTime.setMinutes(minutes);
            bookingDateTime.setSeconds(0);
            bookingDateTime.setMilliseconds(0);

            const currentTime = new Date();
            const timeDifferenceInMs = bookingDateTime - currentTime;
            const timeDifferenceInHours = timeDifferenceInMs / (1000 * 60 * 60);

            // let actualStartTime = new Date(startTime);
            // if (isNaN(actualStartTime.getTime())) {
            //   console.error("Invalid startTime, setting to current time.");
            //   actualStartTime = new Date();
            // }
            // const formattedStartTime = actualStartTime
            //   .toISOString()
            //   .split("T")[1];
            // const bookingDateTime = new Date(
            //   `${date.split("T")[0]}T${formattedStartTime}`
            // );
            // const currentTime = new Date();
            // const timeDifference = bookingDateTime - currentTime;
            return (
              <div>
                <div key={_id} className="encourage-card">
                  <img src={courseId?.image?.[0] || person} alt="Course" />
                  <h3>{new Date(date).toDateString()}</h3>
                  <h4>{courseId?.title || "Unknown Course"}</h4>
                  <p>
                    {/* Time: {new Date(startTime).toLocaleTimeString()} -{" "}
                    {new Date(endTime).toLocaleTimeString()} */}
                    Time: {startTime} - {endTime}
                  </p>
                  <p>
                    Status: <strong>{status}</strong>
                  </p>
                  <p>
                    Booking Type: <strong>{bookingType}</strong>
                  </p>
                  <div className="final-btns">
                    {/* Download Invoice Button */}
                    <button
                      onClick={() => handlePrint(_id)}
                      style={{
                        marginTop: "10px",
                        padding: "10px 15px",
                        backgroundColor: "#849348",
                        color: "white",
                        border: "1px solid #849348",

                        borderRadius: "5px",
                        cursor: "pointer"
                      }}
                    >
                      Invoice
                    </button>
                    {timeDifferenceInHours > 2 && status !== "Cancelled" ? (
                      <button
                        onClick={() => handleCancel(_id, date, startTime)}
                        style={{
                          marginTop: "10px",
                          padding: "10px 15px",
                          backgroundColor: "#fff",
                          color: "#849348",
                          border: "1px solid #849348",
                          borderRadius: "5px",
                          cursor: "pointer"
                        }}
                      >
                        Cancel
                      </button>
                    ) : null}
                  </div>

                  {/* Invoice Template (Hidden by default) */}
                  <div
                    id={`invoice-${_id}`}
                    className="hidden-template"
                    style={{ display: "none" }}
                  >
                    <div className="invoice-container">
                      <div className="booking-heading-new">
                        <img src={logo} alt="Company Logo" />

                        <div className="">
                          <h1 className="invoice-title">Booking Invoice</h1>
                          <p>
                            Thank you for booking with us! Here's your invoice.
                          </p>
                        </div>
                      </div>
                      {/* <div className="invoice-header">
                      <img src={logo} alt="Company Logo" />
                      <h1 className="invoice-title">Booking Invoice</h1>
                      <p>Thank you for booking with us! Here's your invoice.</p>
                    </div> */}

                      <table className="invoice-table">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Course Name:</strong>
                            </td>
                            <td>{courseId?.title || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Booking Name:</strong>
                            </td>
                            <td>{booking?.userId?.name || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Email:</strong>
                            </td>
                            <td>{booking?.userId?.email || "N/A"}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Date:</strong>
                            </td>
                            <td>{new Date(date).toLocaleDateString()}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Start Time:</strong>
                            </td>
                            <td>{startTime}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>End Time:</strong>
                            </td>
                            <td>{endTime}</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Status:</strong>
                            </td>
                            <td>{status}</td>
                          </tr>
                        </tbody>
                      </table>

                      <div className="invoice-footer">
                        <p>
                          For any queries, contact our support at
                          info@aluradubai.com
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No bookings found.</p>
        )}
      </div>

      {/* Cancel Confirmation Dialog */}
      {showCancelDialog && (
        <div className="cancel-dialog">
          <p>Are you sure you want to cancel this booking?</p>
          <button
            onClick={handleConfirmCancel}
            style={{
              marginRight: "10px",
              padding: "10px 15px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            Confirm
          </button>
          <button
            onClick={() => setShowCancelDialog(false)}
            style={{
              padding: "10px 15px",
              backgroundColor: "#FF5733",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default BookingDetails;
